export default __webpack_public_path__ + "static/media/diagram-ko-mobile.cb3e8dcc.jpg";